import { IHttpError } from '@core/interfaces/error.interface';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PublicActions = createActionGroup({
  source: 'MT_ASCUP PUBLIC',
  events: {
    initStart: emptyProps(),
    initEnd: props<{
      publicSystemParams: Record<string, string>;
    }>(),
    requestPublicSystemParams: emptyProps(),
    requestPublicSystemParamsSuccess: props<{
      publicSystemParams: Record<string, string>;
    }>(),
    requestPublicSystemParamsError: props<{ error: IHttpError }>(),
  },
});
